import { MediaHelpers } from '@wajeez-web/core/api';
import React from 'react';

import {
  BaseComponentProps,
  useComponentData,
} from '../../helpers/contentHooks';
import { ClickableComponentLayout } from '../../layouts/ClickableComponentLayout';

export interface LargeRectangleItemParameters {
  image: string | null;
  category: string | undefined;
}

export const LargeRectangleItem = React.forwardRef<
  HTMLDivElement,
  BaseComponentProps
>(({ component, context, isLastSibling }, ref) => {
  const { getParameterValue, content, isLockedContent } =
    useComponentData<LargeRectangleItemParameters>(component, context);

  const image = getParameterValue('image');

  return (
    <ClickableComponentLayout content={content}>
      <div
        ref={ref}
        className={`w-full py-4 sm:py-0 flex sm:flex-col items-start justify-start ${
          !isLastSibling && 'border-b-[0.5px]'
        } border-[#C6C6C8] dark:border-dark-divider sm:border-none`}
      >
        <div
          style={{
            backgroundImage:
              'url(' + MediaHelpers.getPublicMediaById(image) + ')',
          }}
          className={`relative h-[94px] sm:h-[150px] w-[94px] sm:w-auto min-w-[94px] sm:min-w-[150px] border sm:border-none bg-cover bg-center bg-no-repeat mb-[4px] rounded-[10px]`}
        >
          {isLockedContent && (
            <div className="w-[25px] h-[25px] absolute bottom-[10px] left-[10px]">
              <img
                src="../../assets/images/lock.png"
                alt="lock"
                className="block w-full h-full"
              />
            </div>
          )}
        </div>
        <div className="self-stretch ps-2 sm:px-0 sm:pt-2 flex flex-col justify-center items-start">
          <div className="text-[15px] pb-[3px] font-medium sm:font-bold sm:text-[#545454]">
            {content?.title}
          </div>
        </div>
      </div>
    </ClickableComponentLayout>
  );
});
